import { render } from "./IdentityValidation.vue?vue&type=template&id=1a27471c&scoped=true"
import script from "./IdentityValidation.vue?vue&type=script&lang=js"
export * from "./IdentityValidation.vue?vue&type=script&lang=js"

import "./IdentityValidation.vue?vue&type=style&index=0&id=1a27471c&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a27471c"]])

export default __exports__